function DashboardMember() {
  return (
    <>
      <main>
        <h2>DashboardMember</h2>
      </main>
    </>
  );
}

export default DashboardMember;
